import { TILES_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { ITilesCollectionOptionsResponseData, ITilesCollectionResponse } from "@/api_framework/api_modals/Tiles";
import { setTilesConsultation } from "@/app_redux/reducers/slices/auth/tiles_slice";

AxiosCurlirize(axios, () => {});
export const useTilesConsultationAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const execute = useCallback(
    async (type: string, mode: string): Promise<ITilesCollectionOptionsResponseData[] | undefined> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const res: AxiosResponse<ITilesCollectionResponse> = await axios.get(
          `${TILES_MODULE?.TILES_CONSULTATION_API?.baseURL}?type=${type}&mode=${mode}`,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        if (res.data.status === true) {
          dispatch(setTilesConsultation({ data: res.data.data.options }));
          return res.data.data.options;
        } else {
          dispatch(setTilesConsultation({ data: null }));
          return;
        }
      } catch (e: any) {
        if (axios.isAxiosError(e) && e.config) {
          sendCurl(e.config["curlCommand"]);
        }
        captureError(e);
        toast.error("Server Error: " + e.message);
        return;
      }
    },
    [dispatch, configuration, captureError, sendCurl],
  );
  return execute;
};
